<template>
	<div
		class="filters-button"
		:class="{'has-filters': hasFilters}"
		@click="$emit('click')"
	>
		<div
			v-if="showLabel"
			class="filter-label"
		>
			{{ filtersLabel }}
		</div>
		<div class="filter-icon">
			<Icon
				icon-name="filter"
				size="lg"
			/>
		</div>
	</div>
</template>

<script>
export default {
	name:  'FiltersButton',
	props: {
	  	filters: {
	    	type: Array,
		},
		showCount: {
			type:    Boolean,
			default: true,
		},
		showLabel: {
			type:    Boolean,
			default: true,
		},
	},
	computed: {
		filtersLabel() {
	    	if (this.filters.length) {
				let label = this.transUcfirst('one.filtered');
				if (this.showCount) {
					label = label + ` (${this.filtersLength})`;
				}
				return label;
			}
			return this.transUcfirst('commons.filter');
		},
		hasFilters() {
	    	return this.filtersLength > 0;
		},
		filtersLength() {
	    	return this.filters.filter(f => f.count > 0).length;
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.filters-button {
	display: flex;
	cursor: pointer;

	.filter-label {
		margin-right: 18px;
	}

  &.has-filters {
		color: var(--color-hype-yellow);
	}
}
</style>
